/** Opening chats and sending requests to agents: notices and read-only reasons. */
export default {
  denkerHelper: "Denker helper",
  newChat: "New chat",
  chatWithAgent: "Chat with {agent}",
  chatWithAnAgent: "Chat with an agent",
  agentUnavailable: "Agent unavailable",
  projectUnavailable: "Project unavailable",
  runtimeUnavailable: "Runtime unavailable",
  chatStatusUnavailable: "Chat status unavailable",
  chatClosedInCodingApp: "Chat closed in the coding app",
  chatUnavailable: "Chat unavailable",
  chatAgentUnavailable: "This chat's agent is unavailable",
  openingChat: "Opening chat…",
  selectAgainToRetry: "Couldn't connect. Select this chat again to retry.",
  selectAgainToConnect: "Select this chat again to connect.",
  couldNotConnectTitle: "Couldn't connect to that chat",
  couldNotConnectDescription:
    "Select the chat again to retry. Your history is still available.",
  projectArchived: "Project {name} is archived",
  chatProjectUnavailable: "This chat's project is unavailable",
  couldNotOpenChat: "Couldn't open that chat",
  activeChatChanged: "The active chat changed. Please try again.",

  requestDidNotStart: "Agent request did not start",
  windowNotConnected: "This window is not connected to the owner session yet.",
  requestStatusUnknown: "Agent request status unknown",
  deliveryUnconfirmed:
    "Delivery of the saved request is unconfirmed. Check its status before retrying.",
  serverDidNotConfirm:
    "The server did not confirm this request. You can retry without retyping.",
  savedNotDelivered:
    "The request was saved but could not be delivered. Please retry.",
  serverRejected:
    "The server rejected this request. You can retry without retyping.",
  requestQueuedTitle: "Agent request queued",
  requestQueuedDescription:
    "Your request was saved and will start when delivery recovers.",

  replySaved: "Your reply is saved. Waiting for the agent to receive it.",
  replyUnreachable:
    "Your reply was saved, but could not reach the agent. Open this chat to continue.",
  replyContinuedInChat: "Continued in chat",
  replyDelivered: "Reply delivered",

  projectSwitchFailedTitle: "Couldn't switch project",
  projectNotLocal: "{name} is not available locally.",
  selectedProjectNotLocal: "The selected project is not available locally.",
  projectCreateFailed: "Project couldn’t be created",
  tryAgain: "Please try again.",
  attachFailed: "Couldn’t attach file",
  pastedImage: "Pasted image",

  approvalRequest: "A coding session asks for approval",
  directSessionUpdate: "Direct session update",
  backgroundTask: "Background task",
  contextUsage: "{used} / {max} tokens ({percent}%)",
  imageFormat: "IMAGE",
} as const;
